import PlatformLayout from "@/layouts/PlatformLayout";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Settings, Shield, Users, Database, Key } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

const PlatformAdminPage = () => {
  const { user } = useAuth();

  return (
    <PlatformLayout activeTab="admin">
      <div className="p-6 max-w-4xl mx-auto" data-testid="platform-admin">
        <h1 className="text-xl font-bold text-slate-900 mb-6">Administration</h1>

        <div className="grid md:grid-cols-2 gap-4">
          <Card>
            <CardHeader>
              <CardTitle className="text-base flex items-center gap-2">
                <Users className="h-4 w-4 text-blue-600" /> User Management
              </CardTitle>
            </CardHeader>
            <CardContent>
              <div className="space-y-2">
                {[
                  { name: "Admin User", email: "admin@trialeze.com", role: "admin" },
                  { name: "Demo User", email: "demo@trialeze.com", role: "demo" },
                  { name: "Company User", email: "company@trialeze.com", role: "company" },
                ].map((u, i) => (
                  <div key={i} className="flex items-center justify-between p-2 rounded bg-slate-50">
                    <div>
                      <p className="text-sm font-medium">{u.name}</p>
                      <p className="text-xs text-slate-400">{u.email}</p>
                    </div>
                    <Badge variant="outline" className="capitalize text-xs">{u.role}</Badge>
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle className="text-base flex items-center gap-2">
                <Shield className="h-4 w-4 text-emerald-600" /> Platform Status
              </CardTitle>
            </CardHeader>
            <CardContent>
              <div className="space-y-3">
                {[
                  { label: "API Status", value: "Operational", color: "bg-green-500" },
                  { label: "AI Services", value: "Online", color: "bg-green-500" },
                  { label: "Database", value: "Connected", color: "bg-green-500" },
                  { label: "PDF Export", value: "Ready", color: "bg-green-500" },
                ].map((s, i) => (
                  <div key={i} className="flex items-center justify-between">
                    <p className="text-sm text-slate-600">{s.label}</p>
                    <div className="flex items-center gap-2">
                      <div className={`w-2 h-2 rounded-full ${s.color}`} />
                      <p className="text-xs font-medium">{s.value}</p>
                    </div>
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </PlatformLayout>
  );
};

export default PlatformAdminPage;
